import { useSelector } from 'react-redux';
import { selectEnablePreCanned } from '../../../brand/ducks/selectors';
import { useMemo } from 'react';
import { EventWithMarketsAndSelections } from '../sportsbook-types';
import { MarketGroupDto, MarketGroupTags } from '../api/sbapi/sbapi-api-model';

export const filterAndSortMarketGroups = (marketGroups: MarketGroupDto[], isPrecannedAllowed: boolean) => {
	let result = marketGroups;

	// Filter out pre-canned market groups if pre-canned is not allowed.
	if (!isPrecannedAllowed) {
		result = result.filter(marketGroup => !marketGroup.tags.includes(MarketGroupTags.IS_PRECANNED));
	}

	return result
		.filter(marketGroup => marketGroup.marketsCount > 0)
		.sort((g1, g2) => {
			if (g1.order == null) return 1;
			if (g2.order == null) return -1;
			return g1.order - g2.order;
		});
};

/**
 * Hook to extract all available market groups from an event, filter and sort them using filterAndSortMarketGroups utility.
 * @param event
 */
const useEventMarketGroups = (event: EventWithMarketsAndSelections | null) => {
	const isPreCannedEnabled = useSelector(selectEnablePreCanned);

	const marketGroups = useMemo(() => {
		if (!event) {
			return [];
		}

		return filterAndSortMarketGroups(event.marketGroups, isPreCannedEnabled && !event.isLive);
	}, [event, isPreCannedEnabled]);

	return marketGroups;
};

export default useEventMarketGroups;
